import {
  APPLY_CONDITION_TO_SIDES,
  START,
  SUCCESS,
  FAIL
} from "../constants/action-types";
import Mediator from "../services/Mediator";

export const applyConditionToSides = () => {
  return (dispatch, getState) => {
    dispatch({
      type: APPLY_CONDITION_TO_SIDES + START
    });
    (async () => {
      try {
        const {
          condition: {product, variants},
          product: {
            meta: {designs}
          }
        } = getState();
        const assets = await Promise.all(
          designs.map(async (design) => {
            return {
              [design.side]: await Mediator.getProductAssets({
                product,
                style: `small`,
                side: design.side,
                variants
              })
            };
          })
        ).catch((e) => {
          throw new Error(e);
        });
        dispatch({
          type: APPLY_CONDITION_TO_SIDES + SUCCESS,
          payload: {
            assets: assets.reduce((acc, item) => ({...acc, ...item}), {})
          }
        });
      } catch (e) {
        dispatch({
          type: APPLY_CONDITION_TO_SIDES + FAIL,
          error: `Произошла ошибка при загрузке сторон товара`
        });
      }
    })();
  };
};
